import { classNames } from '../../../shared/lib/classNames/classNames'
import { HeaderTypography } from '../../../shared/ui/HeaderTypography/HeaderTypography'
import Paper from '@mui/material/Paper'
import classes from './AppSecretKeyPage.module.scss'
import { ApplicationSecretKey } from '../../../widgets/ApplicationSecretKey'

export const AppSecretKeyPage = () => {
	return (
		<div className={classNames(classes['app-secret-key-page'], {}, [])}>
			<HeaderTypography content="Application secret key" />
			<Paper sx={{
				width: '100%',
				p: '2rem',
				pt: '1rem',
				mt: 4
			}}>
				<ApplicationSecretKey />
			</Paper>
		</div>

	)
}